import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { State } from 'src/app/models/state.model';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'app-leads-navigation',
  templateUrl: './leads-navigation.component.html',
  styleUrls: ['./leads-navigation.component.scss'],
})
export class LeadsNavigationComponent implements OnInit {
  state$: Subscription;
  navigationIndex: number = 0;

  constructor(private appService: AppService) {}

  ngOnInit(): void {
    this.state$ = this.appService.stateSubject.subscribe((state: State) => {
      if (state) {
        this.navigationIndex = state.funnelLeads.navigationIndex;
      }
    });
  }

  setNavigation(index: number) {
    this.appService.stateSubject.next({
      ...this.appService.state,
      funnelLeads: {
        ...this.appService.state.funnelLeads,
        navigationIndex: index,
      },
    });
  }
}
